import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { TipoMaterial } from 'src/app/models/api/comercial/tipo-material';

@Injectable({
  providedIn: 'root'
})
export class ApiTipoMaterialService {
  private baseUrl = 'TipoMaterial';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<TipoMaterial[]>('');
  }

  insert(data: TipoMaterial) {
    return this.controller.unwrap().post<TipoMaterial>('', data);
  }

  update(data: TipoMaterial) {
    return this.controller.unwrap().put<TipoMaterial>('', data);
  }

  delete(id: string) {
    if (!id) { throw new Error('Invalid Argument'); }
    return this.controller.delete(id);
  }
}
